import Pusher from 'pusher-js';

const APP_PUSHER_KEY = process.env?.REACT_APP_PUSHER_KEY;
const APP_PUSHER_CLUSTER = process.env?.REACT_APP_PUSHER_CLUSTER;
const APP_SOCKET_URL = process.env?.REACT_APP_SOCKET_URL;

const authToken = `Bearer ${window.localStorage.getItem('token')}`;

const pusher = new Pusher(APP_PUSHER_KEY || '', {
    cluster: APP_PUSHER_CLUSTER || '',
    authEndpoint: APP_SOCKET_URL || '',
    auth: {
        headers: {
            Authorization: authToken
        }
    }
});

export default pusher